import { Density } from '@philips-emr/tws-constants';
import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Changeable, { ChangeEventListener } from '@philips-emr/tws-core/lib/component/types/changeable';

export interface ChecklistItem {
  key: string;
  label: string;
  value: boolean;
}

class ChecklistAPI extends ComponentAPI implements Changeable<Record<string, boolean>> {

  /** @event */
  @AwesomeEvent
  onChange = new ChangeEventListener<Record<string, boolean>>();

  checkAll(): void {
    const { value: oldValue } = this.state;
    const value = this.getData().map(({ key, label }) => ({ key, label }));

    this.onChange.fire({ value: value, oldValue });
  }

  clear(): void {
    const { value: oldValue } = this.state;

    this.onChange.fire({ value: [], oldValue });
  }

  getData(): ChecklistItem[] {
    return this.state.data;
  }

  setData(data: ChecklistItem[]): void {
    this.setState({ data });
  }

  getDensity(): Density {
    return this.state.density;
  }

  setDensity(density: Density): void {
    this.setState({ density });
  }

  setDisabledKeys(keys: string[]): void {
    this.setState({ disabledKeys: keys });
  }

  getDisabledKeys(): string[] {
    return this.state.disabledKeys;
  }

  isEnabled(): boolean {
    return this.state.enabled;
  }

  setEnabled(enabled: boolean): void {
    this.setState({ enabled });
  }

  isReadOnly(): boolean {
    return this.state.readOnly;
  }

  setReadOnly(readOnly: boolean): void {
    this.setState({ readOnly });
  }

  isShowCheckAll(): boolean {
    return this.state.showCheckAll;
  }

  setShowCheckAll(showCheckAll: boolean): void {
    this.setState({ showCheckAll });
  }

  getValue(): Record<string, boolean> {
    return this.state.value;
  }

  setValue(value: Record<string, boolean>): void {
    const { value: oldValue } = this.state;
    this.setState({ value });

    this.onChange.fire({ value, oldValue });
  }
}

export default ChecklistAPI;
